import { lazyRoute } from '@/routing/lazyRoute';
import { isDesktopRuntime } from './desktopDetection';

/**
 * T-0559: the desktop app's own chrome, chunks of their own. A browser and the phone app never draw
 * either (each returns null outside the desktop runtime), so their launches no longer parse them.
 * Drawn only in the desktop runtime, where `preloadDesktopChrome` has fetched them at boot, beside
 * the session check: by the time the layout draws they render at once, with no frame without them.
 */
export const DesktopTabBarChunk = lazyRoute(
  () => import('./DesktopTabBar'),
  (module) => module.DesktopTabBar,
);

export const DesktopUpdateButtonChunk = lazyRoute(
  () => import('@/features/desktop-download/DesktopUpdateButton'),
  (module) => module.DesktopUpdateButton,
);

/** T-0674: says a desktop command failed and the app is still running (`desktopCommandFailure.ts`). */
export const DesktopCommandFailureNoticeChunk = lazyRoute(
  () => import('./DesktopCommandFailureNotice'),
  (module) => module.DesktopCommandFailureNotice,
);

/** Fetches the desktop chrome at boot, in the desktop runtime only. */
export function preloadDesktopChrome(): void {
  if (!isDesktopRuntime()) return;
  void DesktopTabBarChunk.preload();
  void DesktopUpdateButtonChunk.preload();
  void DesktopCommandFailureNoticeChunk.preload();
}
